import { createContext } from 'react';

const DeleteModalContext = createContext();

export default DeleteModalContext;
